import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=13a31ef0&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=js"
export * from "./ScrollPane.vue?vue&type=script&lang=js"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=13a31ef0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a31ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a31ef0')) {
      api.createRecord('13a31ef0', component.options)
    } else {
      api.reload('13a31ef0', component.options)
    }
    module.hot.accept("./ScrollPane.vue?vue&type=template&id=13a31ef0&scoped=true", function () {
      api.rerender('13a31ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/TagsView/ScrollPane.vue"
export default component.exports